import ProgressContainer from "../../components/uiKits/progress";

const ProgressBar = () => {
  return <ProgressContainer />;
};

export default ProgressBar;
